import styled from '@emotion/styled';

const OuterAppWrapper = styled('div')({
  display: 'flex',
  minHeight: '100vh',
});

export default OuterAppWrapper;
